import React, { useState } from "react";
import styled from "styled-components";
import Employees from "./userlist";
import Logslist from "./activitylog";
import { Link } from "components/link";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import NotificationsSettings from "./notifications";
import Requests from "./requests";
import { ContainerWithSidebar } from "components/layout";
import Quickbooks from "./quickbooks";
import CompanySettings from "views/company_settings";
import ServicePlans from "views/admin/service_plans";
import Categories from "./categories";
import Category from "./categories/category";
import CustomField from "./custom-fields/custom-field";
import CustomFields from "./custom-fields";
import QuoteTemplates from "./quote-templates";
import QuoteTemplate from "./quote-template";
import CustomDocuments from "views/custom_documents";
import TagManager from "../admin/tags/index";
import UploadIndex from "./uploadV2";
import ExportIndex from "./export";
import StripeInfo from "./stripe-information";
import Warranties from "views/warranties";
import Warranty from "views/warranty";
import Geocoding from "./geocoding";
import StripeAPICalls from "./stripe-api-calls.js";
import StripeManagement from "./stripe-management";
import ReprocessPayments from "./reprocess-payments";

import Subscription from "views/subscription";
import SubscriptionAdmin from "views/subscription/subscriptionAdmin";
import UpgradeSub from "views/subscription/upgrade";
import {
  EssentialPlan,
  EnhancedPlan,
  ExclusivePlan,
} from "views/subscription/plans";
import UpdateSubscription from "views/subscription/admin/updateSubscription";
import Duck from "views/time_dashboard";
import { AppointmentTypes } from "./appointment-types";
import UnassignedRequestForm from "views/unassigned_request_form";
import ProductionCentral from "./production";
import { PermissionsIndex } from "./permissions";
import Reminders from "./reminders";
import StatusColors from "./status-colors";
import FileDownload from "./file-download";

import { useTranslation } from "react-i18next";
import TaxManagement from "./tax";
import { useAuthContext } from "contexts/auth";
import Integrations from "./integrations";
import UserManagement from "./user-management";
import MigrationManager from "./migration-manager";
import { getQboTokenInfo, pingQboCompany } from "services/reconciliationService";

// icons
import { IoMdSettings } from "react-icons/io";
import { FaUsers, FaClipboardList, FaMoneyBillWave, FaTasks, FaUserShield } from "react-icons/fa";
import {  MdDashboard } from "react-icons/md";
import { BsChevronLeft, BsChevronRight, BsChevronUp, BsChevronDown } from "react-icons/bs";

const tabs = [
  {
    header: "Control Panel",
    icon: <FaTasks size={20} color="#FFC107" />,
    children: []
  },
  {
    header: "Settings & Configuration",
    icon: <IoMdSettings size={20} color="silver" />, 
    children: [
      { label: "Company Settings", link: "company-settings", path: "/company-settings", component: CompanySettings },
      { label: "Status Colors", link: "status-colors", path: "/status-colors", component: StatusColors },
      { label: "Requests", link: "requests", path: "/requests", component: Requests },
      { label: "Tags", link: "tags", path: "/tags", component: TagManager },
      // { label: "Activity Log", link: "activity-log", path: "/activity-log", component: Logslist },
      { label: "Custom Fields", link: "custom-field", path: "/custom-field", component: CustomFields },
      { label: "Custom Documents", link: "custom-docs", path: "/custom-docs", component: CustomDocuments },
      { label: "Email Reminders", link: "reminders", path: "/reminders", component: Reminders },
      { label: "File Download", link: "file-download", path: "/file-download", component: FileDownload, ownerOnly: true },
    ],
  },
  {
    header: "Finance & Billing",
    icon: <FaMoneyBillWave size={20} color="#4CAF50" />, 
    children: [
      { label: "Quickbooks", link: "quickbooks", path: "/quickbooks", component: Quickbooks },
      { label: "Taxes", link: "tax", path: "/tax", component: TaxManagement },
      { label: "Stripe Payouts", link: "stripeInfo", path: "/stripeinfo", component: StripeInfo },
      { label: "Subscription", link: "subscription", path: "/subscription", component: Subscription },
      // { label: "Stripe API Calls", link: "stripe-api-calls", path: "/stripe-api-calls", component: StripeAPICalls },
    ],
  },
  {
    header: "Scheduling & Operations",
    icon: <MdDashboard size={20} color="#FF9800" />,
    children: [
      { label: "Time Dashboard", link: "time-dashboard", path: "/time-dashboard", component: Duck },
      { label: "Appointment Types", link: "appointment-types", path: "/appointment-types", component: AppointmentTypes },
      { label: "Divisions", link: "divisions", path: "/divisions", component: Categories },
      // { label: "Production Central", link: "production-central", path: "/production-central", component: ProductionCentral },
      { label: "Import", link: "import", path: "/import", component: UploadIndex },
      { label: "Export", link: "export", path: "/export", component: ExportIndex },
    ],
  },
  {
    header: "Employees & Access Control",
    icon: <FaUsers size={20} color="#2196F3" />, 
    children: [
      { label: "Employees", link: "employees", path: "/employees", component: Employees },
      { label: "Notifications", link: "notifications", path: "/notifications", component: NotificationsSettings },
      { label: "Permissions", link: "permissions", path: "/permissions", component: PermissionsIndex },
    ],
  },
  {
    header: "Sales & Quotes",
    icon: <FaClipboardList size={20} color="#E91E63" />, 
    children: [
      { label: "Service Plans", link: "service-plans", path: "/service-plans", component: ServicePlans },
      { label: "Quote Templates", link: "quote-template", path: "/quote-template", component: QuoteTemplates },
      { label: "Warranties", link: "warranty", path: "/warranty", component: Warranties },
    ],
  },
  {
    header: "SuperAdmin Tools",
    icon: <FaUserShield size={20} color="#9C27B0" />,
    children: [
      { label: "User Management", link: "user-management", path: "/user-management", component: UserManagement },
      { label: "Geocoding", link: "geocoding", path: "/geocoding", component: Geocoding },
      { label: "Stripe Management", link: "stripe-management", path: "/stripe-management", component: StripeManagement },
      { label: "Database Migrations", link: "migrations", path: "/migrations", component: MigrationManager },
      { label: "Reprocess Payments", link: "reprocess-payments", path: "/reprocess-payments", component: ReprocessPayments },
    ],
  },
];


export default function Index () {
  const { t } = useTranslation();
  const tBase = "views.admin.index";
  const tr = (key) => t(`${tBase}.${key}`);
  const auth = useAuthContext();
  const { params } = useRouteMatch();
  const history = useHistory();

  const preflightQboConnection = React.useCallback(async () => {
    try {
      // Best-effort preflight to refresh/validate QBO connectivity; do not block navigation.
      await getQboTokenInfo();
      await pingQboCompany();
    } catch (e) {
      // Swallow errors; ConnectionStatusCard will show details on the page.
      // eslint-disable-next-line no-console
      console.debug("QBO preflight ping failed", e);
    }
  }, []);


  // Check if current user has access to superadmin tools
  // PROD IDs: 255, 81, 85, 184, 134, 531, 121
  // DEV IDs: 164 (your dev user ID)
  const allowedUserIds = ["255", "81", "85", "184", "134", "531", "121", "164", "988"];
  
  // 🔍 Helpful logging: Show current user's ID
  React.useEffect(() => {
    if (auth?.user_id) {
      console.log(`👤 Current User ID: ${auth.user_id}, Email: ${auth.email || 'unknown'}`);
      console.log(`🔐 Super Admin Access: ${allowedUserIds.includes(auth.user_id) ? '✅ Granted' : '❌ Denied'}`);
    }
  }, [auth?.user_id]);
  
  const hasSuperAdminAccess = auth && allowedUserIds.includes(auth.user_id);

  // Filter tabs based on user ids
  const filteredTabs = React.useMemo(() => {
    return tabs.filter(tab => {
      if (tab.header === "SuperAdmin Tools") {
        return hasSuperAdminAccess;
      }
      return true; // Show all other tabs
    });
  }, [hasSuperAdminAccess]);

  const [openSections, setOpenSections] = useState({});
  const [selectedSection, setSelectedSection] = useState("Control Panel");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  React.useEffect(() => {
    if (!params.page) {
      setSelectedSection("Control Panel");
      setOpenSections({});
    } else {
      const matchedSection = filteredTabs.find((section) =>
        section.children.some((item) => item.link === params.page)
      );
    
      if (matchedSection) {
        setSelectedSection(matchedSection.header);
        setOpenSections((prev) => ({
          ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}), // Close other sections
          [matchedSection.header]: true, // Open matched section
        }));
      }
    }
  }, [params.page]);

  return (
    <div className="flex h-screen relative">
      {/* Toggle Button - Positioned outside sidebar (hidden for now) */}
      <button
        onClick={toggleSidebar}
        className={`absolute ${isSidebarOpen ? 'left-60' : 'left-4'} top-4 bg-white border border-gray-300 rounded-full p-2 hover:bg-gray-50 transition-all duration-300 z-20 hidden`}
        title={isSidebarOpen ? "Hide Sidebar" : "Show Sidebar"}
      >
        {isSidebarOpen ? (
          <BsChevronLeft className="w-4 h-4 text-gray-600" />
        ) : (
          <BsChevronRight className="w-4 h-4 text-gray-600" />
        )}
      </button>
      
      {/* Sidebar Navigation */}
      <div className={`${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} w-64 border-r border-gray-300 p-4 space-y-2 bg-white select-none transition-transform duration-300 ease-in-out`}>
        {filteredTabs.map((section, index) => (
          <div key={index}>

            {/* Headers */}
            <div
              // onClick={() => toggleSection(section.header)}
              onClick={() => {
                if (section.header === "Control Panel") {
                  setSelectedSection("Control Panel");
                  history.push("/admin");
                  // No need to toggle openSections since there are no children
                } else {
                  setSelectedSection(section.header);
                  toggleSection(section.header);
                }
              }}
              // className={`
              //   flex items-center justify-between font-bold py-2 px-3  rounded-lg cursor-pointer hover:bg-gray-200 transition
              //   ${openSections[section.header] ? "bg-gray-200" : "bg-gray-100"}
              // `}
              className={`
                flex items-center justify-between font-bold py-2 px-3 rounded-lg cursor-pointer hover:bg-gray-200 transition
                ${selectedSection === section.header && section.header === "Control Panel"
                  ? "bg-blue-100" 
                  : openSections[section.header] 
                  ? "bg-gray-200" 
                  : "bg-gray-100"}
              `}
            >
              <div className="flex items-center gap-2">
                {section.icon}
                <span>{section.header}</span>
              </div>
              {section.children.length > 0 && (
                <>
                  {openSections[section.header] ? <BsChevronUp /> : <BsChevronDown />}
                </>
              )}
            </div>

            {/* Children */}
            {openSections[section.header] && (
              <div className="ml-4 space-y-1">
                {section.children.map((item) => {
                  // Check if item is owner-only and user is not owner
                  if (item.ownerOnly && !auth.owner) {
                    return null;
                  }
                  // Check for other auth requirements
                  if (item.requiresAuth && auth.pin !== "KB255") {
                    return null;
                  }
                  return (
                    <Link
                      key={item.label}
                      to={`/admin${item.path}`} // Ensure correct path format
                      className={`block py-1 px-3 rounded transition ${
                        params.page === item.link ? "!bg-blue-100" : " hover:!bg-blue-100"
                      }`}
                      onClick={() => {
                        if (item.link === "quickbooks") {
                          void preflightQboConnection();
                        }
                        setOpenSections((prev) => ({ ...prev, [section.header]: false }));
                      }}
                    >
                      {tr(item.label)}
                    </Link>
                  );
                })}
              </div>
            )}

          </div>
        ))}
      </div>

      {/* Select Content */}
      {params.page ? null : (
        <div className={`flex-1 p-4 border ${!isSidebarOpen ? 'pl-12' : ''}`}>
          <h1 className="text-2xl font-bold">{tr("Control Panel")}</h1>
          <p className="text-gray-600">
            {tr("Welcome to the control panel. Use the sidebar to navigate through the different sections.")}
          </p>
          {filteredTabs.map((section) => { 
              return (
                <div key={section.header} className="mt-2">
                  <div className="flex items-center gap-2">
                    {section.header !== "Control Panel" && section.icon}
                    <h2 className="text-lg font-bold">
                      {section.header !== "Control Panel" && section.header}
                    </h2>
                  </div>
                  <div className="grid grid-cols-4 gap-4 mt-2">
                    {section.children.map((item) => {
                      // Check if item is owner-only and user is not owner
                      if (item.ownerOnly && !auth.owner) {
                        return null;
                      }
                      // Check for other auth requirements
                      if (item.requiresAuth && auth.pin !== "KB255") {
                        return null;
                      }
                      return (
                        <Link
                          key={item.label}
                          to={`/admin${item.path}`} // Ensure correct path format
                          className="p-4 bg-white rounded-lg shadow-sm flex items-center justify-center gap-2"
                          onClick={() => {
                            if (item.link === "quickbooks") {
                              void preflightQboConnection();
                            }
                          }}
                        >
                          {item.icon}
                          <span>{tr(item.label)}</span>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )
            }
          )}

        </div>
      )}


      {/* Content Routes */}
      <div className={`flex-1 p-4 overflow-auto ${!isSidebarOpen ? 'pl-12' : ''}`}>
        <Switch>
          {filteredTabs.flatMap((section) =>
            section.children.map((item) => {
              // Check if item is owner-only and user is not owner
              if (item.ownerOnly && !auth.owner) {
                return null;
              }
              // Check for other auth requirements
              if (item.requiresAuth && auth.pin !== "KB255") {
                return null;
              }
              return (
                <Route key={item.path} path={`/admin${item.path}`} exact component={item.component} />
              );
            })
          )}
          <Route path="/admin/quote-template/:id" component={QuoteTemplate} />
          <Route path="/admin/divisions/:id" component={Category} />
          <Route path="/admin/warranty/:id" component={Warranty} />
          <Route path="/admin/warranty/new" component={Warranty} />
        </Switch>
      </div>
    </div>
  );
}
